export const SCRIPTSURE_SYNC_CONSTANTS = {
  TOP_LEVEL_ID: 'scriptsure-sync-dashboard',
  TABLE_NAME: 'scriptsure-sync-table',
  TITLE: 'ScriptSure sync',
  EMPTY_STATE_MESSAGE: 'No records to display',
  LOAD_ERROR_MESSAGE: "We're sorry, we were unable to load sync failures.",
  KEBAB_ARIA_LABEL: (patient: string) => `Sync failure options for ${patient}`,
  FIX_PROFILE_LABEL: 'Fix profile',
  RESYNC_SUCCESS_MESSAGE: 'Patient record successfully synced with ScriptSure.',
  RESYNC_ERROR_MESSAGE:
    "We're sorry, we were unable to resync patient. Please try again",
  MAUD_ACCESS_ERROR_MESSAGE:
    'You need Maud permissions to access patient charts. Please contact your administrator to request access.',
  COLUMN_HEADERS: {
    PATIENT_NAME: 'Patient name',
    EMAIL: 'Email',
    FAILURE_REASON: 'Failure reason',
    FAILURE_TIME: 'Failure time',
  },
} as const;
